export const ReportCSS = `
@page {
    size: Letter;
    margin: 0.4in;
}
/* body{
  font-family: 'Courier New', Courier, monospace;
} */

.page{
    width: 100%;
    height: 255mm;
    font-family:"Calibri", 'Gill Sans';
    letter-spacing: normal;
}
.page5{
    width: 100%;
    /* height: 255mm; */
    /* font-family:'Courier New', Courier, monospace; */
    letter-spacing: normal;
}

.bold{
    font-weight: bold;
}
.flex{
    display: flex;
}

.cover-page{
    position: relative;
    size: Letter;

}

.cover-img-container{
    width: 100%;
    height: 45%;
    position: relative;
    align-items: center;
    justify-content: center;
}

.cover-img-container img{
    position: absolute;
    bottom: 20%;
    left: 10%;
}

.footer {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
}
.footer p{
    margin:0.3rem;
}

.header{
    display: flex;

  }
  .header .logo{
    min-width: 350px;
    /* min-height: 80px; */
    /* margin-left: 1rem; */
    margin-right: 0.5rem;
  }

  .logo img {
    height: 100%;
    width: 100%;
    object-fit: contain;
  }

.address p{
    margin: 0.4rem;
}

.address{
    padding-left: 1em;
}

.logos{
    margin-top: 5%;
}

.schneider-logo{
    display: flex;
    justify-content: end;
    width: 100%;
    padding: 0;
}

.schneider-logo img{
    height: 80%;
    padding-top: 15px;
}

.address .bottom{
    margin-top: 1rem;
}

.body p li{
    font-size: large;

}

li{
    margin: 8px 0;
}


.estar-score{
    height: 250px;
    min-width: 30%;
    align-items: center;
    display: flex;
    text-align: center;
}
.estar-score .score-container{
    width: 100%;
    height: 80%;
    text-align: center;
}

.estar-score .score{
    font-size: 8em;
}

.estar-score .no-score{
    font-size: 5em;
}
.property{
    width: 70%;
}

.estar-data{
    background-color: #73c4e7d7;
}

.property .row{
    width: 100%;
    font-size: 0.7em;
}

.row-1 th{
    font-size: 0.75em;
}

.fs {
    font-size: 0.75em;
}

.fxs{
    font-size: 0.5em;
}

.bgrey{
    /* background-color: rgba(255, 248, 248, 0.286); */
    background-color: rgba(155, 154, 154, 0.582);
}

/* Last Page */
.bl{
  border-left: black solid 2px;
}
.bb{
  border-bottom: black solid 2px;;
}
.bt{
  border-top: black solid 2px;;
}
.br{
  border-right: black solid 2px;
}
.bg-blue{
  background-color: #5b9bd5;
}

.energy-table{
  width: 100%;
  border: solid black 1px;
  margin-top: 2rem;
  border-collapse: collapse;
}
.energy-table th, .rates-table th, .cost-savings-table th, .cost-table th{
  text-align: left;
}

.rates-table, .cost-savings-table, .cost-table, .degreedays-data-table{
  margin-top: 1rem;
  width: 80%;
  border: solid black 1px;
  border-collapse: collapse;
}

.degreedays-data-table{
  margin:1rem;
  width: 95%;
}
.degreedays-data-table td{
  padding: 0.5rem;
  text-align: center;
}
.degreedays-data-table th{
  text-align: center;
}
.rates-table td, .cost-table td, .cost-savings-table td{
  /* padding-left: 1em; */
  padding-right: 1em;

}

.cost-table{
  width: 90%;
}
.cost-table th{
  padding-right: 0.5em;
}
.border{
  border: black solid 2px;;
}
`